
<div class="custom-modal">
  <form [formGroup]="quizForm">

    <div class="modal-header">
      <h4 class="create-account text-center">Create New Quiz</h4>
      <button class="close-btn" type="button" (click)="closeDialog()"></button>
    </div>

    <div class="modal-body">
      <label for="quizTitle">Quiz Title</label>
      <input id="quizTitle" class="quiz-input mb-2" type="text" formControlName="quiz_name"
        placeholder="Enter Your Quiz Title" />


      <label>Select Course</label>

      <div class="search-dropdown mb-3" (click)="$event.stopPropagation()">

        <input type="text" class="search-input" placeholder="Search course..." [(ngModel)]="searchText"
          [ngModelOptions]="{ standalone: true }" (focus)="openDropdown()" (input)="openDropdown()" />
        <div class="selected-course" *ngIf="selectedCourse">
          Selected: <strong>{{ selectedCourse.name }}</strong>
        </div>

        <div class="dropdown-list" *ngIf="isDropdownOpen">

          <div class="dropdown-item" *ngFor="let course of filteredCourses" (click)="selectCourse(course)">
            {{ course.name }}
          </div>

          <div *ngIf="hasMore()" class="dropdown-item text-center">
            <button (click)="loadCourses()" [disabled]="loading" class="btn-add">
              {{ loading ? 'Loading...' : 'Load More' }}
            </button>
          </div>

          <div class="dropdown-item empty" *ngIf="searchText.length >= 1 && filteredCourses.length === 0">
            No courses found
          </div>
        </div>
      </div>

      <label>Time Limit</label>
      <div class="time-limit-section">
        <div class="time-inputs">
          <div class="time-field mb-2">
            <input type="number" min="0" placeholder="00" formControlName="hours" />
            <span>Hrs</span>
          </div>

          <div class="time-field mb-2">
            <input type="number" min="0" max="60" placeholder="00" formControlName="minutes" />
            <span>Min</span>
          </div>

          <div class="time-field mb-2">
            <input type="number" min="0" max="60" placeholder="00" formControlName="seconds" />
            <span>Sec</span>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="cancel-btn" type="button" (click)="closeDialog()">Cancel</button>

      <button class="create-btn" type="button" (click)="createQuiz()" [disabled]="quizForm.invalid || isCreating">

        <ng-container *ngIf="isCreating; else createText">
          <span class="spinner-text">
            <mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>
            Creating...
          </span>
        </ng-container>

        <ng-template #createText>
          <i class="bi bi-plus"></i>
          Create Quiz
        </ng-template>

      </button>
    </div>
  </form>
</div> 